import {Component, Input, OnInit} from '@angular/core';
import {Hub} from '../types/hub';

@Component({
  selector: 'grafana-link',
  template: `<span><a
href="https://monaghan.hubcontrols.com/d/740PPkQik/hub-admin-link?refresh=15m&orgId=1&var-hubid={{inHub.hubid}}"
target="grafana_link_{{inHub.hubid}}">View in Grafana</a></span>`,
  styles: [
    `span { display: block; width: 100%;}`,
    `@media screen and (min-device-width:800px){
      span{ display:inline-block; min-width:7em; width:fit-content; padding-right:1em;}
    }`,
    `a { background-color: #607d8b; color:white; border: none; margin: 5px 10px; padding: 5px 10px; border-radius: 4px; cursor: pointer; }`,
    `a:hover { background-color: #cfd8dc; color:black; }`,
  ]
})

/**
 * The class is very simple and does little more than present a link to Grafana
 */
export class GrafanaLinkComponent {
  @Input() inHub: Hub;

  constructor() { }
}
